import React from 'react';
import { InboxIcon } from 'lucide-react';
export function Panel({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <section className={`rounded-lg border border-gris-200 bg-white shadow-tarjeta ${className}`} data-id="element-893" data-mp="1apkulg4xmaw8">
      {children}
    </section>;
}
export function EncabezadoPanel({
  titulo,
  descripcion,
  accion
}: {
  titulo: string;
  descripcion?: string;
  accion?: React.ReactNode;
}) {
  return <header className="flex items-start justify-between gap-4 border-b border-gris-200 px-5 py-3.5" data-id="element-894" data-mp="1tmm4nfdcf171">
      <div data-id="element-895" data-mp="1ydatemxn1k2h">
        <h2 className="text-sm font-semibold text-marino-800" data-id="element-896" data-mp="1ydkim8auzn74">{titulo}</h2>
        {descripcion && <p className="mt-0.5 text-xs text-gris-500" data-id="element-897" data-mp="22eo1z4s481d3">{descripcion}</p>}
      </div>
      {accion}
    </header>;
}
export function EstadoVacio({
  mensaje,
  sugerencia
}: {
  mensaje: string;
  sugerencia?: string;
}) {
  return <div className="flex flex-col items-center justify-center gap-2 px-6 py-12 text-center" data-id="element-898" data-mp="2ccal63gg6f2v">
      <InboxIcon className="h-6 w-6 text-gris-300" aria-hidden="true" data-id="element-899" data-mp="qf0xx4gnlfui" />
      <p className="text-sm font-medium text-gris-600" data-id="element-900" data-mp="lfnzdmgf6kc3">{mensaje}</p>
      {sugerencia && <p className="max-w-sm text-xs text-gris-400" data-id="element-901" data-mp="lhsez1nol7s7">{sugerencia}</p>}
    </div>;
}
export function Campo({
  etiqueta,
  valor,
  mono = false
}: {
  etiqueta: string;
  valor: React.ReactNode;
  mono?: boolean;
}) {
  return <div data-id="element-902" data-mp="1950hxcxn04r2">
      <dt className="text-2xs font-semibold uppercase tracking-wide text-gris-400" data-id="element-903" data-mp="195s642own07b">{etiqueta}</dt>
      <dd className={`mt-1 text-sm text-gris-800 ${mono ? 'font-mono' : ''}`} data-id="element-904" data-mp="153597nddmp39">{valor}</dd>
    </div>;
}